import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { useConsentStore } from '@/store/consent';

const isAnalyticsEnabled = import.meta.env.VITE_ANALYTICS_ENABLED !== 'false';

export function ConsentBanner() {
  const { t } = useTranslation();
  const hasUserConsentChoice = useConsentStore.use.hasUserConsentChoice();
  const grantAllConsent = useConsentStore.use.grantAllConsent();
  const denyAllConsent = useConsentStore.use.denyAllConsent();

  if (!isAnalyticsEnabled || hasUserConsentChoice) {
    return null;
  }

  return (
    <div className='fixed bottom-0 left-0 right-0 p-3 sm:p-4 z-50 pointer-events-none flex justify-center'>
      <Card
        glassmorphism
        className='pointer-events-auto w-full max-w-3xl rounded-xl border shadow-2xl'
      >
        <div className='p-4 sm:p-5 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between'>
          <div className='space-y-1'>
            <p className='text-sm font-semibold text-foreground'>
              {t('consent.banner.title', 'Your privacy choices')}
            </p>
            <p className='text-xs sm:text-sm text-muted-foreground'>
              {t(
                'consent.banner.description',
                'We use analytics cookies to understand how the app is used and improve your experience. You can accept all or keep only essential cookies.',
              )}
            </p>
          </div>

          <div className='flex flex-col sm:flex-row gap-2 shrink-0'>
            <Button variant='outline' size='sm' onClick={denyAllConsent}>
              {t('consent.banner.reject', 'Reject non-essential')}
            </Button>
            <Button size='sm' onClick={grantAllConsent}>
              {t('consent.banner.accept', 'Accept all')}
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
